/* eslint-disable new-cap */
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import _set from 'lodash/set';
import ConvertEngine from './convert/convertEngine';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import {
    enumerateGroup,
} from '@src/slide/domain/ui-model/element-modeles/property/group-operation/enumerate';
import { getElementModelConstructorByType } from './factories/element-model-factory';
import AdjustGroupChildrenBg from './property/fill/adjust-group-children-bg';
import { observable } from 'mobx';
import { IGroupFrameProperty } from './property/frame/group/index.interface';
import GroupFrame from './property/frame/group';
import { GroupRefreshMenu } from './property/menu-property/refresh/group';
import ElementBaseModel from './base-modeles/element-base-model';
import { IGroupModelProps } from './Interface/model-props/group-model-props.interface';
import { IShape3D } from '@src/slide/domain/ui-model/element-modeles/property/3d/property3d.interface';
import { IGifPictureModel } from './Interface/picture-model.interface';
import { isDomGifPictureModel, isGroupModel } from '../elements/element-judge';
import { IGroupShapeDataModel } from '@tencent/slide-sdk-model';
import ModelConverterBridge from '@src/slide/domain/ui-model/element-modeles/convert/model-converter-bridge';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';

class GroupModel extends ElementBaseModel implements IGroupModel {
    public static convertDataUiToSdk(uiData, sdkData, rawUiData) {
        ModelConverterBridge.convertUiToSdk({ type: UIModelType.GROUP, uiData, sdkData, rawUiData });
    }

    public static async convertDataSdkToUi(sdkData, uiData, rawSdkData, option?) {
        super.convertDataSdkToUi(sdkData, uiData, rawSdkData, option);
        const convertPromises: Array<Promise<any> | IBaseModel> = [];
        const convertGroupTask = ModelConverterBridge.convertSdkToUi({
            type: UIModelType.GROUP,
            sdkData,
            uiData,
        });
        convertPromises.push(convertGroupTask);

        if (sdkData?.shapeList && sdkData?.shapeList.length > 0) {
            const convertChildrenPromise = ConvertEngine.convertArrayDataSdkToUi(
                getElementModelConstructorByType,
                rawSdkData.shapeList,
                uiData.children,
                uiData,
                option,
            );
            convertPromises.push(convertChildrenPromise);
        }

        if (uiData.parent?.asyncConvertChildren) {
            await Promise.all(convertPromises);
            _set(uiData, 'asyncConvertChildren', false);
        }
    }

    /**
     *
     * @param sdkData       用于转换使用的SDK 数据 不一定是binding 的SDK 数据recursion
     * @param uiData        转换到的目标的UImodel 数据
     * @param rawSdkData    UIModel binding 的SDK 数据
     */
    // eslint-disable-next-line complexity
    public static didConvertDataSdkToUi(sdkData, uiData, rawSdkData, optionObject) {
        super.didConvertDataSdkToUi(sdkData, uiData, rawSdkData, optionObject);

        const resetFrameRecursion = (group) => {
            group.children.forEach((item) => {
                if (item.type === UIModelType.GROUP) {
                    resetFrameRecursion(item);
                }
                item.resetFrame();
            });
        };

        resetFrameRecursion(uiData);
        if (
            (
                sdkData.props.spPr?.solidFill
                || sdkData.props.spPr?.gradFill
                || sdkData.props.spPr?.blipFill
                || sdkData.props.spPr?.pattFill
                || sdkData.props.spPr?.noFill
            )
            && !sdkData.props.spPr?.grpFill
        ) {
            new AdjustGroupChildrenBg(uiData).adjustChildBg(sdkData.props.spPr);
        }

        if (uiData.isRootGroup && !uiData.groupReFreshMenuInstance) {
            uiData.groupReFreshMenuInstance = new GroupRefreshMenu(uiData);
            uiData.groupReFreshMenuInstance.addRefreshGroupItemValues();
        }
    }

    declare public props: IGroupModelProps;
    public sdkData: IGroupShapeDataModel | null = null;
    @observable public refreshGroupByChildrenWithoutChangeSet = 0;
    public groupChildFrameChangedByChildren: any;
    public childResizeFinished = false;  // 标志子元素缩放结束
    private groupFrameInstance: IGroupFrameProperty;
    private groupReFreshMenuInstance: GroupRefreshMenu;

    public constructor(props?: {}) {
        super(props);
        this.type = UIModelType.GROUP;
        this.props.childFrame = { left: 0, top: 0, width: 0, height: 0 };
    }

    public unbindSDK() {
        super.unbindSDK();
        this.groupReFreshMenuInstance?.removeRefreshGroupItemValues();
        for (let i = 0; i < this.children.length; i++) {
            this.children[i]?.unbindSDK();
        }
    }
    public getGifsInGroup(): IGifPictureModel[] {
        function recursiveGetGifsInGroup(groupModel?: IGroupModel) {
            return groupModel?.children.reduce((res, model) => {
                if (isDomGifPictureModel(model)) {
                    return res.concat(model);
                }
                if (isGroupModel(model)) {
                    return res.concat(...recursiveGetGifsInGroup(model));
                }
                return res;
            }, [] as IGifPictureModel[]);
        }
        return recursiveGetGifsInGroup(this);
    }

    public get scaleX() {
        const childWidth = this.sdkData?.props?.spPr?.xfrm?.chExt?.cx;
        if (this.sdkData?.props?.spPr?.xfrm?.ext?.cx !== undefined
            && childWidth !== undefined && childWidth > 0) {
            return this.sdkData?.props?.spPr?.xfrm?.ext?.cx / childWidth;
        }
        return 1.0;
    }

    public get scaleY() {
        const childHeight = this.sdkData?.props?.spPr?.xfrm?.chExt?.cy;
        if (this.sdkData?.props?.spPr?.xfrm?.ext?.cy !== undefined
            && childHeight !== undefined && childHeight > 0) {
            return this.sdkData?.props?.spPr?.xfrm?.ext?.cy / childHeight;
        }
        return 1.0;
    }

    public get isRootGroup(): boolean {
        let isRootGroup = true;
        enumerateGroup(this, () => {
            isRootGroup = false;
            return true;
        });
        return isRootGroup;
    }

    public getFrame(): IGroupFrameProperty {
        if (!this.groupFrameInstance) {
            this.groupFrameInstance = new GroupFrame(this);
        }
        return this.groupFrameInstance;
    }

    public get shape3d(): IShape3D | undefined {
        return this.get3DProperty().getGroupShape3D();
    }

    public set shape3d(shape) { /** no-op */ }
}

export default GroupModel;
